export const createTicker = () => {
  const TICKER_KEY = Symbol('ticker');
  const tickerHandlers = new Map();

  let tickerPreloadCallTimeout = null;
  let tickerInterval = null;

  const runTicker = async (req) => {
    const data = await req();

    if (!tickerHandlers.size) {
      return;
    }

    const handlers = tickerHandlers.get(TICKER_KEY) || [];

    handlers.forEach(fn => fn(data));
  };

  const usePreloadCallsStrategy = ({ strategy, cb, finalizeCb }, _callStack = []) => {
    if (!strategy.length && (!_callStack.length || _callStack[1] < 1)) {
      finalizeCb();
      return;
    }

    let nextStrategy = strategy;

    if (!_callStack.length || _callStack[1] < 1) {
      // eslint-disable-next-line no-param-reassign
      [_callStack] = strategy;
      [, ...nextStrategy] = strategy;
    }

    tickerPreloadCallTimeout = setTimeout(() => {
      cb();

      usePreloadCallsStrategy({
        strategy: nextStrategy,
        finalizeCb,
        cb,
      }, [_callStack[0], _callStack[1] - 1]);
    }, _callStack[0]);
  };

  return {
    /**
     * Ticker loader
     *
     * @param withInitialCall
     * @param intervalMSec
     * @param preloadCallsStrategy - is array of preload call timeouts configs,
     *        e.g.: [[3000, 3], [5000, 3]], first - timeout MSec; second - calls count
     * @param req
     */
    loadTicker: ({
      withInitialCall = false,
      intervalMSec = 10000,
      preloadCallsStrategy = null,
      req = () => {},
    } = {}) => {
      if (withInitialCall) {
        runTicker(req);
      }

      if (preloadCallsStrategy) {
        usePreloadCallsStrategy({
          strategy: preloadCallsStrategy,
          finalizeCb: () => {
            tickerInterval = setInterval(() => runTicker(req), intervalMSec);
          },
          cb: req,
        });
      } else {
        tickerInterval = setInterval(() => runTicker(req), intervalMSec);
      }
    },

    stopTicker() {
      clearTimeout(tickerPreloadCallTimeout);
      clearInterval(tickerInterval);
    },

    destroyTicker: () => {
      clearTimeout(tickerPreloadCallTimeout);
      clearInterval(tickerInterval);

      tickerHandlers.delete(TICKER_KEY);
    },

    subscribeToTicker: (cb) => {
      const subscribers = tickerHandlers.get(TICKER_KEY) || [];

      tickerHandlers.set(TICKER_KEY, [...subscribers, cb]);
    },

    unsubscribeFromTicker: (cb) => {
      if (cb) {
        const subscribers = tickerHandlers.get(TICKER_KEY) || [];
        tickerHandlers.set(TICKER_KEY, subscribers.filter(_cb => _cb !== cb));
      } else {
        tickerHandlers.delete(TICKER_KEY);
      }
    },
  };
};
